// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1ye9n","dragIcon":"Choice_dragIcon__3ZFSG","left":"Choice_left__iO-2w","input":"Choice_input__1vFti"};